import { THEME } from "@/themes/types";
import { SiteInfo } from "../types";
import { SiteConfigFactory } from "../factories/siteConfigFactory";

export const DOMAINS = {
  "qrcreator.com": "qrcreator.com",
  "fastqrgenerator.com": "fastqrgenerator.com",
  "onlineqrcode.com": "onlineqrcode.com",
  "qrnow.com": "qrnow.com",
  "localhost:8001": "localhost:8001",
};

export enum DomainName {
  QRCreator = "qrcreator.com",
  FastQRGenerator = "fastqrgenerator.com",
  OnlineQRCode = "onlineqrcode.com",
  QRNow = "qrnow.com",
  Localhost = "localhost:8001",
}

/**
 * Gets the site configuration for the local environment based on the theme.
 * This is specific to local development and the old theme-based logic.
 */
export const getLocalConfigByTheme = (): SiteInfo => {
  const theme = process.env.NEXT_PUBLIC_THEME as THEME;
  switch (theme) {
    case "mojito":
      return SiteConfigFactory.create(DomainName.QRCreator);
    case "daikiri":
      return SiteConfigFactory.create(DomainName.FastQRGenerator);
    case "kalimotxo":
      return SiteConfigFactory.create(DomainName.OnlineQRCode);
    case "negroni":
      return SiteConfigFactory.create(DomainName.QRNow);
    default:
      return SiteConfigFactory.create(DomainName.QRCreator);
  }
};

export const domains: { [x: string]: SiteInfo } = {
  "qrcreator.com": SiteConfigFactory.create(DomainName.QRCreator),
  "fastqrgenerator.com": SiteConfigFactory.create(DomainName.FastQRGenerator),
  "onlineqrcode.com": SiteConfigFactory.create(DomainName.OnlineQRCode),
  "qrnow.com": SiteConfigFactory.create(DomainName.QRNow),
  localhost: getLocalConfigByTheme(),
};

export type DomainsType = keyof typeof DOMAINS;
